



export const modal = () => {

  const modal = document.querySelector(".modal");

  //const modalInsert = document.querySelector(".presentations-modal__insert");

  const modalBtn = document.querySelector(".js-invite-button");

  const modalClose = document.querySelector(".modal__inner span");


  if ( modalBtn ){

    modalBtn.addEventListener("click",function(){
      modal.classList.add("modal_open");
    });

  }
  

  if ( modalClose ){

    modalClose.addEventListener("click",function(){
      modal.classList.remove("modal_open");
    });

    modal.addEventListener("click",function(event){
      if (this == event.target){
        modal.classList.remove("modal_open");
      }
    });

    document.addEventListener('keydown', function(e) {
      let keyCode = e.keyCode;
      if (keyCode === 27) {//keycode is an Integer, not a String
        modal.classList.remove("modal_open");
      }
    });

  }
  


}